// Typography scale matching Tailwind config and design system
export const TYPOGRAPHY = {
  // Font families
  FONTS: {
    INTER: ["Inter", "sans-serif"],
    MONTSERRAT: ["Montserrat", "sans-serif"],
    POPPINS: ["Poppins", "sans-serif"],
  },

  // Desktop Typography Scale
  DESKTOP: {
    LOGO: "1.375rem", // 22px - Logo text
    BADGE: "1.25rem", // 20px - Early Access badge
    HERO_TITLE: "3.375rem", // 54px - Main headline
    HERO_PARA: "2.25rem", // 36px - Hero paragraph
    EMAIL_INPUT: "1.25rem", // 20px - Email placeholder/input
    CTA_BUTTON: "1.5rem", // 24px - Join Waitlist button
  },

  // Tablet Typography Scales (Foundation: 768px breakpoint = 52px from Figma)
  TABLET: {
    SM: {
      HERO_TITLE: "3.25rem", // 52px - Foundation size from Figma design at 768px
      HERO_PARA: "1.375rem", // 22px - Paragraph for iPad Mini
      EMAIL_INPUT: "1.125rem", // 18px - Email input for iPad Mini
      CTA_BUTTON: "1.25rem", // 20px - CTA button for iPad Mini
    },
    MD: {
      HERO_TITLE: "3.5rem", // 56px - Scaled up for iPad Air (834px+)
      HERO_PARA: "1.5rem", // 24px - Paragraph for iPad Air
      EMAIL_INPUT: "1.1875rem", // 19px - Email input for iPad Air
      CTA_BUTTON: "1.375rem", // 22px - CTA button for iPad Air
    },
    LG: {
      HERO_TITLE: "3.75rem", // 60px - Scaled up for iPad Pro (1024px+)
      HERO_PARA: "1.75rem", // 28px - Paragraph for iPad Pro
      EMAIL_INPUT: "1.25rem", // 20px - Email input for iPad Pro
      CTA_BUTTON: "1.5rem", // 24px - CTA button for iPad Pro
    },
  },

  // Portrait-specific typography (optimized for vertical layouts)
  PORTRAIT: {
    HERO_TITLE: "2.75rem", // 44px - Portrait title (between md/lg)
    HERO_PARA: "1.625rem", // 26px - Portrait paragraph
    EMAIL_INPUT: "1.1875rem", // 19px - Portrait email input
    CTA_BUTTON: "1.375rem", // 22px - Portrait CTA button
  },

  // Mobile Typography Scale (320px-767px)
  MOBILE: {
    TITLE: "2.25rem", // 36px - Main title for mobile (375px+)
    TITLE_SM: "1.875rem", // 30px - Smaller screens (320px-374px)
    SUBTITLE: "1.25rem", // 20px - Subtitle text
    SUBTITLE_SM: "1.125rem", // 18px - Smaller screens
    BODY: "1rem", // 16px - Body/description text
    BODY_SM: "0.875rem", // 14px - Smaller screens
    BUTTON: "1rem", // 16px - Button text
    BUTTON_SM: "0.875rem", // 14px - Smaller screens
    LOGO: "1.125rem", // 18px - Logo text on mobile
    LOGO_SM: "1rem", // 16px - Smaller screens
    BADGE: "0.875rem", // 14px - Early Access badge mobile
    BADGE_SM: "0.75rem", // 12px - Smaller screens
  },

  // Font weights
  WEIGHTS: {
    LIGHT: 300,
    NORMAL: 400,
    MEDIUM: 500,
    SEMIBOLD: 600,
    BOLD: 700,
    EXTRA_BOLD: 800,
  },

  // Line heights
  LINE_HEIGHTS: {
    TIGHT: "1.296", // Hero title line height
    RELAXED: "1.625", // Body text line height
    NORMAL: "1.5", // Default line height
  },
};

// Text shadow values from the design
export const TEXT_SHADOWS = {
  HERO_DESKTOP: "0 4.2px 0 rgba(0, 0, 0, 0.2)",
  HERO_MOBILE_STRONG:
    "0 6px 12px rgba(0, 0, 0, 0.3), 0 2px 4px rgba(0, 0, 0, 0.2)",
  HERO_MOBILE_MEDIUM:
    "0 4px 8px rgba(0, 0, 0, 0.3), 0 1px 2px rgba(0, 0, 0, 0.2)",
  HERO_MOBILE_LIGHT: "0 2px 4px rgba(0, 0, 0, 0.3)",
};
